/* Add-on guard: add-on products (product type "Add-on") can only be bought
 * alongside a real product. Theme-level only — a direct /cart/<id>:1 checkout
 * permalink bypasses it; airtight enforcement needs a Cart Validation Function. */
(function () {
  'use strict';

  var ADDON_TYPE = 'Add-on';
  var cfg = window.ADDON_GUARD || {};
  var MESSAGE = cfg.message || 'Add-ons can only be purchased together with a costume, so they were removed from your cart.';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;

  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function orphanAddons(cart) {
    var hasReal = cart.items.some(function (i) { return i.product_type !== ADDON_TYPE; });
    return hasReal ? [] : cart.items.filter(function (i) { return i.product_type === ADDON_TYPE; });
  }

  // Resolves true when it had to remove add-ons.
  function enforce() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      var orphans = orphanAddons(cart);
      if (!orphans.length) return false;
      var updates = {};
      orphans.forEach(function (i) { updates[i.key] = 0; });
      return nativeFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return true; });
    }).catch(function () { return false; })
      .then(function (changed) { busy = false; return changed; });
  }

  function enforceAndRefresh() {
    return enforce().then(function (changed) {
      if (changed) { window.alert(MESSAGE); window.location.reload(); }
      return changed;
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(enforceAndRefresh, 0); }).catch(function () {});
    }
    return p;
  };

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    var t = el.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-checkout-button], #checkout, .cart__checkout-button');
    return t;
  }

  document.addEventListener('click', function (e) {
    var t = isCheckoutTrigger(e.target);
    if (!t || t.dataset.addonGuardOk) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    enforce().then(function (changed) {
      if (changed) { window.alert(MESSAGE); window.location.reload(); return; }
      window.location.href = '/checkout';
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var sub = e.submitter;
    var toCheckout = (f.action && /\/checkout/.test(f.action)) || (sub && sub.name === 'checkout');
    if (!toCheckout) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    enforce().then(function (changed) {
      if (changed) { window.alert(MESSAGE); window.location.reload(); return; }
      window.location.href = '/checkout';
    });
  }, true);

  enforceAndRefresh();
})();
